import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { AddEditBrandComponent } from './addEditBrand.component';

//import * as fromCommonStore from '../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { BrandModel } from '../../../model/index';
import { BrandService } from '../../../services/index';

@Component({
    selector: 'brand-tab',
    templateUrl: './brand.component.html',
})
export class BrandMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public branddata: any[] = [];

    isLoadMask: Promise<any>;
    brandData: BrandModel[];
    isLoading: boolean = false;

    constructor(public store: Store<fromRootStore.State>, private brandService: BrandService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'NAME', prop: 'name', width: 370, minWidth: 370, maxWidth: 370 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 70, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getBrandList();
        }
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getBrandList();
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getBrandList();
    }

    getBrandList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.brandService
            .getBrandList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.brandData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditBrand(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditBrandComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Brand Details';
        //this.bsModalRef.content.mode = 'Add';
        //this.bsModalRef.content.branddata = {};
        this.bsModalRef.content.branddata = Object.assign({}, row);
        this.bsModalRef.content.brandLoadEvent.subscribe(($e) => {
            that.getBrandList();
            this.store.dispatch(new commonActions.LoadAllBrand());
        });
    }

    // onEditBrand(row: any): void {
    //     this.bsModalRef = this.modalService.show(AddEditBrandComponent, {
    //         keyboard: false,
    //         ignoreBackdropClick: true
    //     });
    //     this.bsModalRef.content.branddata = Object.assign({}, row);
    //     this.bsModalRef.content.title = 'Edit BRAND Details';
    //     this.bsModalRef.content.mode = 'Edit';
    //     this.bsModalRef.content.branddata = row;
    // }

    onDeleteBrand(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Brand: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.brandService
                .deleteBrand(row.brand_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getBrandList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/brand/brand.component.ts